import {
  TComponentDetails,
  TContentHubSeriesDetailsProps,
  TSeriesDetailsData,
} from "../types/ContentHubSeriesDetails.type";

export class SeriesDetailsModel {
  public readonly data?: TSeriesDetailsData;

  constructor(props: TContentHubSeriesDetailsProps) {
    this.data = props?.fields?.apiData || null;
  }
  get innerComponents(): TComponentDetails[] {
    return this.data?.innerComponents ?? [];
  }

  get eyebrow(): string | undefined {
    return this.data?.eyebrow;
  }

  get title(): string | undefined {
    return this.data?.title;
  }

  get description(): string | undefined {
    return this.data?.description;
  }
}
